// extracted by mini-css-extract-plugin
export default {"loader-view":"LoaderView_loader-view__+7WKO","loader-view-progress-bar":"LoaderView_loader-view-progress-bar__Vl9gC","loader-view-children":"LoaderView_loader-view-children__Puzur"};